export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/react-transition-group/esm/config.js
// module id = 608
// module chunks = 0